import React, { useState } from "react";
import { Typography, Button, Form, Card, message, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Title } = Typography;

const VideoSubmissionPage = () => {
  const [videoFile, setVideoFile] = useState(null);
  const [videoFileName, setVideoFileName] = useState("");

  const handleVideoUpload = (file) => {
    const isMP4 = file.type === "video/mp4";
    const isFileSizeValid = file.size / 1024 / 1024 < 100; // Max file size 100 MB
    const isDurationValid = true; // You'll need to implement duration validation

    if (isMP4 && isFileSizeValid && isDurationValid) {
      setVideoFile(file);
      setVideoFileName(file.name);
    } else {
      message.error(
        "Please upload an MP4 file with duration less than 90 seconds and less than 100 MB in size."
      );
    }
  };

  const handleSubmit = () => {
    // Implement video submission logic, such as uploading to a server or cloud storage
    // You can also integrate with services like AWS S3 and Elastic Transcoder for video processing

    // Example: Upload video to a server
    const formData = new FormData();
    formData.append("video", videoFile);

    // Make a POST request to your server with the formData
    // Example:
    // fetch('/api/upload-video', {
    //   method: 'POST',
    //   body: formData
    // })
    // .then(response => {
    //   // Handle response
    //   ////console.log('Video uploaded successfully');
    // })
    // .catch(error => {
    //   console.error('Error uploading video:', error);
    // });

    // Clear the form after submission
    setVideoFile(null);
    setVideoFileName("");
    message.success("Video submitted successfully");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card
        style={{
          width: "50%",
          padding: "30px",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={2} style={{ textAlign: "center", marginBottom: "20px" }}>
          Video Submission
        </Title>
        <Form onFinish={handleSubmit}>
          <Form.Item
            label="Upload Video"
            name="video"
            rules={[{ required: true, message: "Please upload your video" }]}
          >
            <Upload
              beforeUpload={handleVideoUpload}
              fileList={videoFile ? [videoFile] : []}
              accept=".mp4"
              showUploadList={{ showPreviewIcon: false }}
            >
              <Button icon={<UploadOutlined />}>Select Video (Max 90s)</Button>
            </Upload>
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              disabled={!videoFile}
              style={{ width: "100%" }}
            >
              Submit Video
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default VideoSubmissionPage;
